import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  getAnalyticsConsent,
  initializeGoogleAnalytics,
  setAnalyticsConsent,
  trackPageView,
} from "@/lib/analytics";

const GRANTED = "granted";
const DENIED = "denied";

export function AnalyticsManager() {
  const location = useLocation();
  const measurementId = (process.env.REACT_APP_GA_MEASUREMENT_ID || "").trim();
  const [consent, setConsent] = useState(() => getAnalyticsConsent());

  useEffect(() => {
    if (!measurementId || consent !== GRANTED) {
      return;
    }

    if (initializeGoogleAnalytics(measurementId)) {
      trackPageView(`${location.pathname}${location.search}${location.hash}`);
    }
  }, [
    consent,
    location.hash,
    location.pathname,
    location.search,
    measurementId,
  ]);

  if (!measurementId || consent === GRANTED || consent === DENIED) {
    return null;
  }

  const chooseConsent = (value) => {
    setAnalyticsConsent(value);
    setConsent(value);
  };

  return (
    <div
      className="fixed inset-x-4 bottom-4 z-[1000] mx-auto max-w-3xl rounded-2xl border border-white/10 bg-zinc-950/95 p-4 text-left text-white shadow-2xl backdrop-blur md:flex md:items-center md:gap-5"
      role="dialog"
      aria-label="Analytics preferences"
    >
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold">Help us improve Bikeparks Finder</p>
        <p className="mt-1 text-sm leading-5 text-zinc-300">
          We use optional Google Analytics to understand which parks, trails and features
          are useful. Analytics only starts if you allow it.
        </p>
      </div>
      <div className="mt-4 flex shrink-0 gap-2 md:mt-0">
        <button
          type="button"
          className="rounded-lg border border-zinc-700 px-3 py-2 text-sm font-medium text-zinc-200 transition hover:bg-zinc-800"
          onClick={() => chooseConsent(DENIED)}
        >
          Reject
        </button>
        <button
          type="button"
          className="rounded-lg bg-white px-3 py-2 text-sm font-semibold text-zinc-950 transition hover:bg-zinc-200"
          onClick={() => chooseConsent(GRANTED)}
        >
          Allow analytics
        </button>
      </div>
    </div>
  );
}
